var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "70 Basic icons by Xicons.co") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,20H45a0,0,0,0,1,0,0V40a4,4,0,0,1-4,4H7a4,4,0,0,1-4-4V20A0,0,0,0,1,3,20Z",
    fill: "#f0f0f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41,6H7a4,4,0,0,0-4,4V20H45V10A4,4,0,0,0,41,6Z",
    fill: "#ec5044"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,13a2,2,0,0,1-2-2V3a2,2,0,0,1,4,0v8A2,2,0,0,1,14,13Z",
    fill: "#495660"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34,13a2,2,0,0,1-2-2V3a2,2,0,0,1,4,0v8A2,2,0,0,1,34,13Z",
    fill: "#495660"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.39,38.5A2,2,0,0,1,20,37.9l-5.39-5.53a2,2,0,0,1,2.87-2.79l4,4.12L30.63,25A2,2,0,0,1,33.37,28L22.76,38A2,2,0,0,1,21.39,38.5Z",
    fill: "#495660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCalendar);
export default __webpack_public_path__ + "static/media/red-calendar.6b20a163f0a5719b698e38c46b1f390e.svg";
export { ForwardRef as ReactComponent };